export default __webpack_public_path__ + "static/media/pattern002.028eb05a.mp3";